import type { ReactNode } from 'react';
import { navigate, type Route } from '../boot/router';
import type { AppUser } from '../boot/session';
import { EmptyState } from '../shell/State';
import { SettingsPage } from './Settings';
import { DashboardPage } from './Dashboard';
import { EditorPage } from './Editor';
import { ProjectDetailPage } from './ProjectDetail';
import { ProjectsPage } from './Projects';
import { ComparePage } from './Compare';
import { BlockAdminPage } from './BlockAdmin';
import { ActivityPage } from './Activity';

export function renderRoute(route: Route, user: AppUser): ReactNode {
  switch (route.name) {
    case 'dashboard':
      return <DashboardPage user={user} />;

    case 'projects':
      return <ProjectsPage user={user} />;

    case 'project':
      return <ProjectDetailPage projectId={route.projectId} user={user} />;

    case 'admin':
      return <SettingsPage user={user} />;

    case 'drawing':
      return <EditorPage drawingId={route.drawingId} user={user} />;

    case 'version':
      return (
        <EditorPage
          drawingId={route.drawingId}
          versionId={route.versionId}
          user={user}
          readOnly
        />
      );

    case 'compare':
      return <ComparePage drawingId={route.drawingId} a={route.a} b={route.b} />;

    case 'blocks':
      return <BlockAdminPage user={user} />;

    case 'activity':
      return <ActivityPage user={user} />;

    case 'notfound':
      return (
        <div className="page">
          <div className="card">
            <EmptyState
              icon="🧭"
              title="존재하지 않는 화면입니다"
              desc={route.raw}
              action={
                <button
                  type="button"
                  className="btn btn--primary"
                  style={{ marginTop: 10 }}
                  onClick={() => navigate({ name: 'dashboard' }, true)}
                >
                  대시보드로 이동
                </button>
              }
            />
          </div>
        </div>
      );
  }
}
